var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"export-status-indicator"},[_c('spinner'),_c('span',[_vm._v("Generando archivo"+_vm._s(Object.keys(_vm.pendingExports).length > 1 ? 's' : ''))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }